import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERSTATUSSUCCESSHEADERBLOCK_LEGACY_FIELD_ORDER = [
  "text",
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderStatusSuccessHeaderBlockDescriptor: _generatedOrderStatusSuccessHeaderBlockDescriptor,
  orderStatusSuccessHeaderBlockBlocDefinition,
  orderStatusSuccessHeaderBlockDashboardLayout,
  orderStatusSuccessHeaderBlockConfig,
  orderStatusSuccessHeaderBlockResolveConfig,
  orderStatusSuccessHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Order status success",
    componentType: 'OrderStatusSuccessHeaderBlockComponent',
    category: 'navigation',
    description: "Order status success.",
    keywords: [],
    allowedIn: [{ bloc: 'OrderStatusPageComponent', slot: 'body' }],
    sharedFields: {}
  },

  () => ({
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-status-success-header.text.label",
        help: "pages.blocks.order-status-success-header.text.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.order-status-success-header.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.order-status-success-header.background-color.label",
      }
    })
  }),

  () => ({
    omitFields: ["background_color"] as const,
    tabs: [
      {
        label: "pages.blocks.order-status-success-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.order-status-success-header.fieldset.message.label",
            fields: ["text", "text_color"],
          },
        ],
      },
    ],
  })
);

export function orderStatusSuccessHeaderBlockDescriptor(): IBlockDescriptor;
export function orderStatusSuccessHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderStatusSuccessHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderStatusSuccessHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderStatusSuccessHeaderBlockDescriptor, orderStatusSuccessHeaderBlockProperties, fieldOrder);
}

export {
  orderStatusSuccessHeaderBlockBlocDefinition,
  orderStatusSuccessHeaderBlockDashboardLayout,
  orderStatusSuccessHeaderBlockProperties,
  orderStatusSuccessHeaderBlockConfig,
  orderStatusSuccessHeaderBlockResolveConfig,
};

export type OrderStatusSuccessHeaderBlockConfig = typeof orderStatusSuccessHeaderBlockConfig;
